import React, { useRef } from 'react'
import { ImageIcon, PaperclipIcon } from 'lucide-react'

import { Button } from '@components/ui/button'

const FileInput = ({ disabled, fileType, ...props }) => {
  const fileInputRef = useRef()

  // Determine which icon to use based on fileType
  const Icon = fileType === 'document' ? PaperclipIcon : ImageIcon

  return (
    <>
      <Button
        variant='ghost'
        size='icon'
        disabled={disabled}
        type='button'
        htmlFor='upload-button'
        onClick={() => fileInputRef.current.click()}
        className='!size-8'
      >
        <Icon
          data-tutorial='vision-step'
          className='size-4'
        />
      </Button>

      <input
        ref={fileInputRef}
        id='upload-button'
        type='file'
        // Accepts image files, but also allows plain text.
        // This allows Android 14 devices to select from the file picker and use the camera.
        // Remove text/plain as an option once this Android 14 bug is fixed: https://issuetracker.google.com/issues/317289301
        accept='.jpg,.jpeg,.png,.heic,.heif,.webp,text/plain'
        multiple
        className='hidden'
        disabled={disabled}
        {...props}
      />
    </>
  )
}

export default FileInput
